export default __webpack_public_path__ + "static/media/lockbox_horz_white_text.e551adb7.svg";